import { useMemo } from 'react'

import { ImageRatio, MenuConfig, MenuTemplate } from 'src/apollo/sites'

import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'

import { getTemplateClass } from 'public/components/default_template/menu_section/MenuItemCard'
import { overrideConfigBasedOnTemplate } from 'public/components/default_template/menu_section/menuStylingOverrides'

const TEMPLATE_MAP = {
  [MenuTemplate.Classic]: MenuTemplate.Classic,
  [MenuTemplate.LeftImageV2]: MenuTemplate.LeftImageV2,
  [MenuTemplate.TopImageV2]: MenuTemplate.LeftImageV2 // override
} as Record<MenuTemplate, MenuTemplate>

const RATIO_MAP = { [MenuTemplate.TopImageV2]: ImageRatio.Smaller } as Record<
  MenuTemplate,
  ImageRatio
>

const DEFAULT_TEMPLATE = MenuTemplate.Classic
const DEFAULT_RATIO = ImageRatio.Smaller

export const useReorderTemplate = () => {
  const {
    restaurant: { config }
  } = useRestaurant()

  return useMemo(() => {
    const configuredTemplate = config.ooConfig?.format?.template
    const finalTemplate =
      (configuredTemplate ? TEMPLATE_MAP[configuredTemplate] : undefined) ??
      DEFAULT_TEMPLATE
    let ratioOverride = undefined

    if (!configuredTemplate || !TEMPLATE_MAP[configuredTemplate]) {
      // If not using a template we support, ensure we use a default ratio with the default template
      ratioOverride = DEFAULT_RATIO
    } else if (configuredTemplate) {
      // Since we're overriding the template if top image is configured, we also have to override the
      // ratio since top has different ones that don't work with left/classic.
      // Only use the configured ratio if left/classic is explicitly configured.
      ratioOverride = RATIO_MAP[configuredTemplate] ?? undefined
    }

    const templateOverrides = {
      ...overrideConfigBasedOnTemplate(config.ooConfig as MenuConfig, config),
      ...(ratioOverride !== undefined
        ? { imageRatio: `imageRatio${ratioOverride}` }
        : {})
    }
    const templateClass = getTemplateClass(finalTemplate)

    return { templateOverrides, templateClass }
  }, [config])
}
